{
    "Authentication_LoginButton": "Registrazione",
    "LoginForm_LoginTitle": "Accedi al tuo account",
    "LoginForm_WelcomeBack": "Bentornato! Inserisci i tuoi dati.",
    "LoginForm_Email": "Nome utente",
    "LoginForm_EmailRequired": "L'email è obbligatoria",
    "LoginForm_InvalidEmail": "Il nome utente deve essere un indirizzo email",
    "LoginForm_EmailPlaceholder": "Inserisci la tua email",
    "LoginForm_Password": "Password",
    "LoginForm_PasswordRequired": "La password è obbligatoria",
    "LoginForm_PasswordPlaceholder": "••••••••",
    "LoginForm_RememberMe": "Ricordati di me",
    "LoginForm_ForgotPassword": "Ha dimenticato la password",
    "LoginForm_SignIn": "Registrazione",
    "NAME": "Authentication",
    "LoginForm_Username": "Nome utente",
    "LoginForm_UsernameRequired": "Il nome utente è obbligatorio",
    "LoginForm_UsernamePlaceholder": "Inserisci il tuo nome utente",
    "LoginForm_CME": "ECM",
    "LoginForm_Or": "(O)",
    "LoginForm_Server": "Server",
    "LoginForm_ServerPlaceholder": "Seleziona il server a cui effettuare l'accesso",
    "LoginForm_LoginLanding_UserOnMultipleServices": "Questo nome utente esiste su più servizi. Fornisci ulteriori informazioni per identificare il tuo utente.",
    "LoginForm_LoginLanding_UserNonAdmin_Error": "Si è verificato un problema durante l'accesso al tuo account. Contatta l'amministratore per risolvere il problema.",
    "LoginForm_LandingPage_NextButton": "Continuare",
    "Authentication_ChangeBrowserProfile": "Cambia profilo del browser",
    "LoginForm_LoginLanding_User_Not_Found_Error": "Non siamo riusciti a trovare il nome utente inserito. Controlla nuovamente e riprova."
}